import * as React from 'react';
import { Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, SxProps, Theme } from '@mui/material';
import { ButtonBlueprint } from '../../factories';
import { Toolbar, ToolbarProps } from '../Toolbar';
import { Typography } from '../Typography';

const styles: Record<string, SxProps<Theme>> = {
  dialogContentText: {
    padding: 1
  }
};

// @deprecated
export interface _DeprecatedModalProps {
  open: boolean;
  title?: string;
  helperText?: string;
  disableBackdropClick?: boolean;
  toolbarItems?: ButtonBlueprint[];
  contentItems?: JSX.Element[];
  formId?: string;
  onClose?: React.ReactEventHandler<{}>;
  fullWidth?: boolean;
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const createToolbar = (items: ButtonBlueprint[]): any => {
  const toolbar: ToolbarProps['items'] = [
    {
      id: 1,
      position: 'right',
      items
    }
  ];

  return <Toolbar items={toolbar} />;
};

const createContent = (contentItems: any) => contentItems.map((item: any) => item);

// @deprecated
const _DeprecatedModal: React.FunctionComponent<_DeprecatedModalProps> = ({
  contentItems,
  title,
  open,
  helperText,
  toolbarItems,
  onClose,
  // disableBackdropClick,
  fullWidth,
  maxWidth
}) => {
  const { dialogContentText } = styles;
  return (
    <React.Fragment>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        onClose={onClose}
        // disableBackdropClick={disableBackdropClick}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
      >
        {title && <DialogTitle id="form-dialog-title">{title}</DialogTitle>}
        <DialogContent aria-labelledby="form-dialog-text">{contentItems && contentItems.length > 0 && createContent(contentItems)}</DialogContent>
        <DialogActions>{toolbarItems && toolbarItems.length > 0 && createToolbar(toolbarItems)}</DialogActions>
        {helperText && (
          <DialogContentText id="form-dialog-text" sx={dialogContentText}>
            <Typography variant="caption">{helperText}</Typography>
          </DialogContentText>
        )}
      </Dialog>
    </React.Fragment>
  );
};

_DeprecatedModal.displayName = 'Modal';

export { _DeprecatedModal };
